import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { IStipoDocumento, TipoDocumento } from "../../types/tipoDocumento/TipoDocumento";
import { useCreateTipoDocumento1Mutation } from "./tipoDocumentoApiSlice";
import { TipoDocumentoForm } from "./TipoDocumentoForm";


export const TipoDocumentoCreate = () => {

    const [tipoDocumento, setTipoDocumento] = useState<TipoDocumento>(IStipoDocumento);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createTipoDocumento, status] = useCreateTipoDocumento1Mutation();
    const navigate = useNavigate();


    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setTipoDocumento((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handleCorpoChangeQuill = (value: string) => {
        setTipoDocumento((prev) => ({
            ...prev,
            conteudo: value,
        }));
        console.log("REact quill value", value);
    };



    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createTipoDocumento(tipoDocumento);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(configUrls.TIPO_DOCUMENTO_LIST_RT);
            // setTipoDocumento(IStipoDocumento);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Tipos de Documentos
                </Typography>



                <TipoDocumentoForm
                    data={tipoDocumento}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleCorpoChangeQuill={handleCorpoChangeQuill}
                />

            </Paper>










        </>







    );










};

/*
 <TipoDocumentoTurmaForm
                    tipoDocumentoTurma={tipoDocumentoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/